<div class="menu-items">
    <div class="menu-item" *ngIf="!isXcelerateRedirect" [ngClass]="{'selected-menu': url?.includes('portal/personal-info')}" (click)="navigateTo('portal/personal-info')">
        <img alt="personal-information" *ngIf="!url?.includes('portal/personal-info')" src="{{assetsUrl}}PersonalInfo.png">
        <img alt="personal-information-active" *ngIf="url?.includes('portal/personal-info')" src="{{assetsUrl}}PersonalInfo-Active.png">
        <div class="text">Personal Information</div>
    </div>
    <div class="menu-item" *ngIf="!iSuperAdminUser && !isXcelerateRedirect && ((!isSearchedOfficeManagerUser && !iBranchAdminUser))
    && !officeManagerAgentSearch" [ngClass]="{'selected-menu': url?.includes('/portal/website-listing')}"
     (click)="navigateTo('/portal/website-listing')">
        <img alt="websiteAndListings" *ngIf="!url?.includes('/portal/website-listing')" src="{{assetsUrl}}WebsiteListing.png">
        <img alt="websiteAndListings-active" *ngIf="url?.includes('/portal/website-listing')"
            src="{{assetsUrl}}WebsiteListing-Active.png">
        <div class="text">Website and Listings</div>
    </div> 
    <div class="menu-item"
     [ngClass]="{'selected-menu': url?.includes('/portal/subscriptions')}"
    (click)="navigateTo('/portal/subscriptions')">
        <img alt="subscriptions" *ngIf="!url?.includes('/portal/subscriptions')" src="{{assetsUrl}}Subscription.png">
        <img alt="subscriptions-active" *ngIf="url?.includes('/portal/subscriptions')" src="{{assetsUrl}}Subscription-Active.png">
        <div class="text">Subscriptions</div>
    </div>
    <div class="menu-item" *ngIf="!isXcelerateRedirect"
        [ngClass]="{'selected-menu':url?.includes('/portal/leads-crm')}"
        (click)="navigateTo('/portal/leads-crm/rental-lead')" >
        <img alt="leadsCRM" *ngIf="!url?.includes('/portal/leads-crm')" src="{{assetsUrl}}LeadsCRM.png">
        <img alt="leadsCRM-active" *ngIf="url?.includes('/portal/leads-crm')"
            src="{{assetsUrl}}LeadsCRM-Active.png">
        <div class="text">Leads / CRM</div>
    </div>
    <div class="menu-item" *ngIf="showMenuForManager()"
    [ngClass]="{'selected-menu': url?.includes('/portal/office-showcase')}" (click)="navigateTo('/portal/office-showcase')">
        <img alt="office-showcase"  *ngIf="!url?.includes('/portal/office-showcase')" src="{{assetsUrl}}officeShowcase.png">
        <img alt="office-showcase-active" *ngIf="url?.includes('/portal/office-showcase')"
            src="{{assetsUrl}}officeShowcase-active.png">
        <div class="text">Office Showcase</div>
    </div>
    <div class="menu-item" 
    *ngIf="showAgentSitesForManager() && !isDelegateUser"
        [ngClass]="{'selected-menu':isMenuSelected('agent-sites')}"  (click)="openOfficeManagerSearch()">
        <img alt="agent-sites" *ngIf="!isMenuSelected('agent-sites')" src="{{assetsUrl}}agentSites.png">
        <img alt="agent-sites-active" *ngIf="isMenuSelected('agent-sites')"
            src="{{assetsUrl}}agentSites-Active.png">
        <div class="text">Agent Sites</div>
    </div>
    <div class="menu-item" *ngIf="!isXcelerateRedirect"
        [ngClass]="{'selected-menu': url?.includes('/portal/website-account')}" (click)="navigateTo('/portal/website-account')">
        <img alt="websiteAccount" *ngIf="!url?.includes('/portal/website-account')" src="{{assetsUrl}}WebsiteAccounts.png">
        <img alt="websiteAccount-active" *ngIf="url?.includes('/portal/website-account')"
            src="{{assetsUrl}}WebsiteAccounts-Active.png">
        <div class="text">Website Account</div>
    </div>
    <div class="menu-item imgOfficeCoreService" *ngIf="showMenuForManager()"
    [ngClass]="{'selected-menu': url?.includes('/portal/office-core-service')}" (click)="navigateTo('/portal/office-core-service')" >
        <img alt="OfficeCoreService" *ngIf="!url?.includes('/portal/office-core-service')" src="{{assetsUrl}}OfficeCoreService.png">
        <img alt="OfficeCoreService-active" *ngIf="url?.includes('/portal/office-core-service')"
            src="{{assetsUrl}}OfficeCoreService-Active.png">
        <div class="text">Office Core Services</div>
    </div>
    <div *ngIf="showTeamWebsiteMenu" class="menu-item"
        [ngClass]="{'selected-menu':url?.includes('/portal/team-website')}" (click)="navigateToTeamWebsite()">
        <img alt="teamWebsite" *ngIf="!url?.includes('/portal/team-website')" src="{{assetsUrl}}team-website.png">
        <img alt="teamWebsite-active" *ngIf="url?.includes('/portal/team-website')"
            src="{{assetsUrl}}team-website-active.png">
        <div class="text">Team Website</div>
    </div>
    <div class="menu-item" *ngIf="showMenuForManager()"
        [ngClass]="{'selected-menu': url?.includes('/portal/office-websites')}" (click)="navigateTo('/portal/office-websites')">
        <img alt="Officewebsite" *ngIf="!url?.includes('/portal/office-websites')" src="{{assetsUrl}}Officewebsite.png">
        <img alt="Officewebsite-active" *ngIf="url?.includes('/portal/office-websites')"
            src="{{assetsUrl}}Officewebsite-Active.png">
        <div class="text">Office Websites</div>
    </div>
</div>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="redirectToNewMenu()"
  #changeMenuModal
>
</app-search-update-confirmation>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="navigateToTeamWebsiteConfirm()"
  #changeTeamWebsiteMenuModal
>
</app-search-update-confirmation>

<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="officeManagerSearchConfirm()"
  #officeManagerSearchModal
>
</app-search-update-confirmation>